<template>
  <div class="containerdiv">
    <div class="left-bottom-sign"></div>
    <!-- #ifdef MP -->
    <div class="back-btn yticon icon-zuojiantou-up" @click="navBack"></div>
    <!-- #endif -->
    <div class="right-top-sign"></div>
    <!-- 设置白色背景防止软键盘把下部绝对定位元素顶上来盖住输入框等 -->
    <div class="wrapper">
      <div class="left-top-sign">{{type}}</div>
      <div class="welcome">绑定手机号!</div>
      <div class="input-content">
        <div class="input-item">
          <span class="tit">手机号码</span>
          <input type="number" v-model="mobile" placeholder="请输入手机号码" maxlength="11" />
        </div>
        <div class="input-item">
          <span class="tit">验证码</span>
          <div class="d-flex flex-row w-100">
            <input
              class="flex-1"
              type="mobile"
              v-model="code"
              placeholder="请输入6位验证码"
              placeholder-class="input-empty"
              maxlength="6"
              @confirm="bindPhone"
            />
            <div
              class="get-code flex-center text-nowrap"
              @click="getCode"
            >{{codeTime!=60?codeTime+'秒后重新获取':'获取验证码'}}</div>
          </div>
        </div>
      </div>
      <div class="confirm-btn" @click="bindPhone" :disabled="logining">绑定</div>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex';

export default {
  data () {
    return {
      mobile: '',
      logining: false,
      code: '',
      codeTime: 60,
      type: 'bind phone'
    }
  },
  computed: {
    ...mapState(['openId'])
  },
  methods: {
    ...mapMutations(['login']),
    navBack () {
      this.$router.go(-1)
    },
    bindPhone () {
      let { mobile, code } = this
      this.logining = true
      this.$http.request(this.$http.pathMap.bindPhone, 'post', { phone: mobile, vcode: code }).then(res => {
        this.logining = false
        this.$toast('绑定成功')
        this.getUserInfo()
        // this.login({})
      }).catch(err => {
        this.logining = false
      })
    },

    getUserInfo () {
      this.$http.request(this.$http.pathMap.userInfo, 'post').then(res => {
        this.login(res.data)
        this.navBack()
      })
    },
    getCode () {
      if (this.codeTime != 60) {
        return
      }
      if(!this.mobile) {
        return this.$toast.fail('请输入手机号')
      }
      let that = this
      let { mobile } = this
      this.$http.request(this.$http.pathMap.bindingVcode, 'get', { phone: mobile }).then(res => {
        this.$toast('验证码发送成功')
        let interval = setInterval(() => {
          if (that.codeTime > 1) {
            that.codeTime -= 1
          } else {
            that.codeTime = 60
            clearInterval(interval)
          }
        }, 1000)
      })
    },
  },

}
</script>

<style lang='scss' scoped>
#app {
  background-color: white;
}
.containerdiv {
  padding-top: 85px;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #fff;
}
.wrapper {
  position: relative;
  z-index: 90;
  /* background: #fff; */
  padding-bottom: 20px;
}
.back-btn {
  position: absolute;
  left: 20px;
  z-index: 9999;
  padding-top: var(--status-bar-height);
  top: 20px;
  font-size: 20px;
  color: $font-color-dark;
}
.left-top-sign {
  font-size: 60px;
  color: $page-color-base;
  position: relative;
}
.right-top-sign {
  position: absolute;
  top: 40px;
  right: -15px;
  z-index: 95;
  &:before,
  &:after {
    display: block;
    content: "";
    width: 200px;
    height: 40px;
    background: #b4f3e2;
  }
  &:before {
    transform: rotate(50deg);
    border-radius: 0 50px 0 0;
  }
  &:after {
    position: absolute;
    right: -99px;
    top: 0;
    transform: rotate(-50deg);
    border-radius: 50px 0 0 0;
    /* background: pink; */
  }
}
.left-bottom-sign {
  position: absolute;
  left: -135px;
  bottom: -160px;
  border: 50px solid #d0d1fd;
  border-radius: 50%;
  padding: 90px;
}
.welcome {
  position: relative;
  left: 25px;
  top: -45px;
  font-size: 23px;
  color: #555;
  text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.3);
}
.input-content {
  padding: 0 30px;
}
.input-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 15px;
  background: $page-color-light;
  height: 60px;
  border-radius: 4px;
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
  .tit {
    height: 25px;
    line-height: 28px;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-base;
  }
  input {
    height: 30px;
    font-size: $uni-font-size-base + 1px;
    color: $font-color-dark;
    width: 100%;
  }
}
.get-code {
  border: 1px $font-color-spec solid;
  border-radius: 25px;
  color: $font-color-spec;
  font-size: $uni-font-size-sm + 1px;
  padding-left: 5px;
  padding-right: 5px;
}
.confirm-btn {
  width: 315px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  border-radius: 50px;
  margin: 35px auto;
  background: var(--theme-font-color);
  color: white;
  font-size: $uni-font-size-lg;
  &:after {
    border-radius: 100px;
  }
}
.forget-section {
  font-size: $uni-font-size-sm + 1px;
  color: $font-color-spec;
  text-align: center;
  margin-top: 20px;
}
.register-section {
  position: absolute;
  left: 0;
  bottom: 25px;
  width: 100%;
  font-size: $uni-font-size-sm + 1px;
  color: $font-color-base;
  text-align: center;
  text {
    color: $font-color-spec;
    margin-left: 5px;
  }
}
</style>
